import { useListAllObjectivesQuery } from "components/commitment-pacing/store/api";
import { useSelector } from "react-redux";
import { isEqual } from "lodash";
import { useGetPortfolios } from "api/ux/src/apis/PortfoliosApi";
import { WorkspaceEntityType } from "components/workspaces/store/types";
import { useDefaultWorkspaceId } from "components/workspaces/hooks/handleWorkspacePreferences";
const getLatestTarget = (objective) => (objective.explicitNavTargets && objective.explicitNavTargets.length > 0
    ? objective.explicitNavTargets.reduce((latest, current) => (current.year > latest.year ? current : latest))
    : null);
const formatEndNavTarget = (latestTarget) => {
    if (!latestTarget || !latestTarget.amount) {
        return null;
    }
    const { currencyCode, units } = latestTarget.amount;
    if (!currencyCode || !units) {
        return null;
    }
    const numericAmount = Number(units);
    return {
        amount: numericAmount,
        currency: currencyCode
    };
};
const hasPortfolio = (objective, portfoliosRecord) => portfoliosRecord[objective.portfolioId];
const transformObjective = (objective, portfoliosRecord, workspaceId) => {
    const latestTarget = getLatestTarget(objective);
    const endNavTarget = formatEndNavTarget(latestTarget);
    const portfolioNameOrId = portfoliosRecord[objective.portfolioId]?.name || objective.portfolioId;
    return {
        EndNavTarget: endNavTarget,
        Id: `${objective.portfolioId}-${objective.name}`,
        IsDefault: objective.isDefault ?? false,
        Name: objective.name,
        PortfolioId: objective.portfolioId,
        PortfolioNameOrId: portfolioNameOrId,
        StartDate: objective.startDate,
        Title: objective.title,
        WorkspaceId: workspaceId
    };
};
const usePacingPlansApi = () => {
    const { data, ...rest } = useListAllObjectivesQuery();
    useGetPortfolios();
    const portfoliosRecord = useSelector((state) => state.entities.Portfolios, isEqual);
    const defaultWorkspaceId = useDefaultWorkspaceId(WorkspaceEntityType.PORTFOLIO);
    const transformedData = data?.filter((objective) => hasPortfolio(objective, portfoliosRecord))
        .map((objective) => transformObjective(objective, portfoliosRecord, defaultWorkspaceId)) || [];
    const queryState = {
        isFinished: rest.isSuccess || rest.isError,
        isPending: rest.isLoading
    };
    return {
        data: transformedData,
        querystate: queryState,
        refresh: rest.refetch
    };
};
export default usePacingPlansApi;
